var e = "undefined" != typeof document && document.querySelector("body"),
  t = "undefined" != typeof document && document.createElement("div");
t && (t.style.overflowY = "scroll", t.style.width = "50px", t.style.height = "50px", t.style.position = "absolute", t.style.visibility = "hidden");
var o = {
  enable: function enable() {
    var o;
    var i = getComputedStyle(e);
    e.style.overflow = "hidden", e.style.width = "calc(100% - ".concat(i.marginLeft, " - ").concat(i.marginRight, ")"), "undefined" != typeof window && window.innerHeight < e.clientHeight && (null === (o = null == e ? void 0 : e.append) || void 0 === o || o.call(e, t), e.style.paddingRight = t.offsetWidth - t.clientWidth + "px", e.style.boxSizing = "border-box");
  },
  disable: function disable() {
    e.style.removeProperty("overflow"), e.style.removeProperty("width"), e.style.removeProperty("padding-right"), e.style.removeProperty("box-sizing"), t.remove();
  }
};
export { o as default };